import React from 'react';
import { Hero, Contact, Testimonials } from '../components/sections';
import AILHLaunchSection from '../components/sections/AILHLaunchSection';
import FeaturedInitiatives from '../components/sections/FeaturedInitiatives';
import { SectionTitle } from '../components/common';
import { useMission } from '../hooks/useMission';

const Home: React.FC = () => {
  const { mission, loading: missionLoading } = useMission();

  const renderMissionSection = () => {
    if (mission) {
      return (
        <section className="about-mission-section py-5">
          <div className="container">
            <SectionTitle subtitle={`[ ${mission.title} ]`} title={mission.heading} />
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <p
                  className="about-mission-text mb-0 text-center"
                  style={{
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    maxWidth: '100%',
                    fontSize: '1.8rem',
                    lineHeight: 1.8,
                    color: '#273351'
                  }}
                >
                  {mission.description}
                </p>
              </div>
            </div>
          </div>
        </section>
      );
    }

    if (!missionLoading) return null;

    return (
      <section
        className="about-mission-section home-section-placeholder home-section-placeholder--mission py-5"
        aria-hidden="true"
      >
        <div className="container">
          <div className="home-section-placeholder__title" />
          <div className="home-section-placeholder__line home-section-placeholder__line--wide" />
          <div className="home-section-placeholder__line" />
        </div>
      </section>
    );
  };

  return (
    <main id="main-content" role="main" style={{ position: 'relative', minHeight: '100vh' }}>
      <div className="layout-content" style={{ position: 'relative', zIndex: 1 }}>
        <div id="wrapper" style={{ position: 'relative', zIndex: 1 }}>
          <Hero />
          {/* Our Mission Section */}
          {renderMissionSection()}
          <AILHLaunchSection />
          <FeaturedInitiatives />
          <Testimonials />
          <Contact />
        </div>
      </div>
    </main>
  );
};

export default Home;
 
